'use strict';

const { strictEqual } = require('assert');

/**
 * Formats a school's name according to some rules, 
 * for rendering in places where we don't want to show the full school name.
 * Current rules:
 *     1. The "Admissions: " prefix is removed if present.
 *
 * @param name {string} The school name.
 */
exports.formatSchoolName = (name) => {

    strictEqual(typeof name, 'string');

    // Remove admissions prefix:
    const admissionsPrefix = 'Admissions: ';
    if (name.startsWith(admissionsPrefix)) {
        return name.substring(admissionsPrefix.length);
    }

    return name;

};
